import { ApiClient, apiClient } from "../../../core/api_client";
import { generateCrudRepoFactory } from "../../../core/crud";
import { ICRUDRepo } from "../../../core/models";
import { budgetHistoryFromJson, budgetHistoryToJson, IBudgetHistory, IBudgetHistoryForm } from "./entities";

interface IBudgetHistoryRepo extends ICRUDRepo<IBudgetHistory, IBudgetHistoryForm> {}

const URL = "v1/budget-history";

const BudgetHistoryRepoImplFactory = (apiClient: ApiClient): IBudgetHistoryRepo => {
  const r: IBudgetHistoryRepo = {
    ...generateCrudRepoFactory<IBudgetHistory, IBudgetHistoryForm>(
      apiClient,
      URL,
      budgetHistoryFromJson,
      budgetHistoryToJson,
    ),
  };

  return r;
};

export const BudgetHistoryRepoImpl = BudgetHistoryRepoImplFactory(apiClient);
